import { render, staticRenderFns } from "./ResourceNav.vue?vue&type=template&id=10a7c8a6&scoped=true&"
import script from "./ResourceNav.vue?vue&type=script&lang=js&"
export * from "./ResourceNav.vue?vue&type=script&lang=js&"
import style0 from "./ResourceNav.vue?vue&type=style&index=0&id=10a7c8a6&prod&lang=scss&scoped=true&"
import style1 from "./ResourceNav.vue?vue&type=style&index=1&id=10a7c8a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../resource-manage/node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a7c8a6",
  null
  
)

export default component.exports